<div *ngIf="showPlaceholder" class="item-placeholder-wrapper">
  <div class="item-placeholder" *ngFor="let row of rows" [class.multiple-rows]="placeholderRows > 1">
    <div class="item-placeholder-text" [style.maxWidth.rem]="width" [style.height.rem]="height"></div>
  </div>
</div>

<ng-content *ngIf="!showPlaceholder"></ng-content>
